export const contact = {
  email: "khushboostar1232@gmail.com",
  phone: "+91-9504386204",
  location: "Parul University, Vadodara, India",
  social: [
    {
      name: "LinkedIn",
      url: "https://linkedin.com/in/khushbookumari15",
      icon: "/assets/icons/linkedin.svg"
    },
    {
      name: "GitHub",
      url: "https://github.com/khushbookumari15",
      icon: "/assets/icons/github.svg"
    },
    {
      name: "Email",
      url: "mailto:khushboostar1232@gmail.com",
      icon: "/assets/icons/email.svg"
    }
  ]
};
